<div class="pagination-container">
  <ul class="pagination justify-content-center">

    <!-- Précédent -->
    <li class="page-item" [class.disabled]="currentPage === 1">
      <a class="page-link" (click)="goToPage(currentPage - 1)">&laquo;</a>
    </li>

    <!-- Page 1 -->
    <li class="page-item" [class.active]="currentPage === 1">
      <a class="page-link" (click)="goToPage(1)">1</a>
    </li>

    <!-- ... après la page 1 si nécessaire -->
    <li *ngIf="visiblePages[0] > 2" class="page-item disabled">
      <span class="page-link">...</span>
    </li>

    <ng-container *ngFor="let page of visiblePages">
      <li *ngIf="page !== 1 && page !== totalPages"
          class="page-item"
          [class.active]="page === currentPage">
        <a class="page-link" (click)="goToPage(page)">{{ page }}</a>
      </li>
    </ng-container>


    <!-- ... avant la dernière page si nécessaire -->
    <li *ngIf="visiblePages[visiblePages.length - 1] < totalPages - 1" class="page-item disabled">
      <span class="page-link">...</span>
    </li>

    <!-- Dernière page -->
    <li class="page-item" [class.active]="currentPage === totalPages" *ngIf="totalPages > 1">
      <a class="page-link" (click)="goToPage(totalPages)">{{ totalPages }}</a>
    </li>

    <!-- Suivant -->
    <li class="page-item" [class.disabled]="currentPage === totalPages">
      <a class="page-link" (click)="goToPage(currentPage + 1)">&raquo;</a>
    </li>
  </ul>
</div>
